// ------------------------------------------------------------------------------------------------
/**
 * @EN Check if the product status is locked
 * @ES Comprobar si el estado de producto está bloqueado
 */
// ------------------------------------------------------------------------------------------------
export const isProductStatusLocked = (
    currentContractStatusId: string | null | undefined,
    departmentBlockedContractStatusIds: string[] | null | undefined
): boolean => {
    if (!currentContractStatusId || !departmentBlockedContractStatusIds?.length) {
        return false;
    }

    return departmentBlockedContractStatusIds.includes(currentContractStatusId);
};
// ------------------------------------------------------------------------------------------------